/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordAuthResponse
 */
export interface DiscordAuthResponse {
    /**
     * 
     * @type {string}
     * @memberof DiscordAuthResponse
     */
    url: string;
}

/**
 * Check if a given object implements the DiscordAuthResponse interface.
 */
export function instanceOfDiscordAuthResponse(value: object): value is DiscordAuthResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function DiscordAuthResponseFromJSON(json: any): DiscordAuthResponse {
    return DiscordAuthResponseFromJSONTyped(json, false);
}

export function DiscordAuthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordAuthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function DiscordAuthResponseToJSON(json: any): DiscordAuthResponse {
    return DiscordAuthResponseToJSONTyped(json, false);
}

export function DiscordAuthResponseToJSONTyped(value?: DiscordAuthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

